'use strict'
/**
 * Ilduomo Module
 */
Ilduomo.service('socket', socketService)
function socketService($http, $state) {
  var socket = io('https://mdfs.spacanino.net:8890')
  return {
    on: function (room, success) {
      socket.on(room, success)
    },
    subscribe: function (channel) {
      socket.emit('subscribe', channel)
    },
    emit: function (eventName, channel) {
      socket.emit(eventName, channel)
    }
  }
};
